module.exports = __webpack_public_path__ + "static/media/ordercards.89e0a466.png";